import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { GeneralSmartParkError } from 'src/types';

const RESOURCE = '/parkings/:parkingId/invitations/:invitationId/';

interface DTO {
    parkingId: string;
    invitationId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ invitationId, parkingId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { invitationId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_INVITATION_RESOURCE, useMutationHook as useDeleteInvitation };
export type { DTO as DeleteInvitationDTO };
